module.exports = __webpack_public_path__ + "static/media/jsla.78167f0e.svg";